
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt, FaEye } from 'react-icons/fa'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import ImageLightbox from '../../../shared/components/ImageLightbox/ImageLightbox'
import api from '../../../utils/api'

import AuthBackgroundImage from '../../../shared/components/AuthImage/AuthBackgroundImage'

import EditAccessory from '../EditAccessory'
//CSS
import "../ListAccessory.css"

import RandomString from '../../../shared/functions/RandomString'
import NumberToMoney from '../../../shared/functions/NumberToMoney'
/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListAccessoryRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, myPermissionViewCost, enableSelect, handleSelect, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditAccessory, setModalEditAccessory] = useState(false)
    const [accessoryId, setAccessoryId] = useState("")
    const [accessoryName, setAccessoryName] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [lightboxItem, setLightboxItem] = useState(null)

    async function deleteAccessory(id) {
        let msgType = 'success'
        const data = await api.delete(`/accessory/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    const handleOnSelect = (item) => {
        if (enableSelect) {
            const id = RandomString(16)
            handleSelect({ ...item, id: id })
        }
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div
                    key={item._id}
                    className={`accessory-card ${enableSelect ? 'accessory-card-selectable' : ''}`}
                    onClick={() => handleOnSelect(item)}
                >
                    <div
                        className='accessory-card-image-wrap'
                        onClick={(e) => { if (item.image) { e.stopPropagation(); setLightboxItem(item) } }}
                    >
                        <AuthBackgroundImage className='accessory-card-image shd-bgimg-cover' src={item.image ? `/images/accessory/${item.image}` : null} />
                        {item.image && (
                            <div className='accessory-card-image-overlay'>
                                <FaEye size={22} />
                            </div>
                        )}
                    </div>

                    <div className='accessory-card-body'>
                        <span className='accessory-card-name'>{item.name}</span>
                        {item.description && (
                            <span className='accessory-card-description'>{item.description}</span>
                        )}
                        <span className='accessory-card-cost'>R$ {NumberToMoney(item.price)}</span>
                        {myPermissionViewCost && (
                            <span className='accessory-card-margin'>
                                Custo: R$ {item.cost ? NumberToMoney(item.cost) : '—'}
                                {item.cost && ` · Lucro: R$ ${NumberToMoney(parseFloat(item.price) - parseFloat(item.cost))}`}
                            </span>
                        )}

                        {!enableSelect && (
                            <div className='accessory-card-footer'>
                                {myPermissionEdit &&
                                    <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={(e) => { e.stopPropagation(); setAccessoryId(item._id); setModalEditAccessory(true) }} />
                                }
                                {myPermissionDelete &&
                                    <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={(e) => { e.stopPropagation(); setModalDeleteItem(true); setAccessoryId(item._id); setAccessoryName(item.name) }} />
                                }
                            </div>
                        )}
                    </div>
                </div>
            ))
        }
    }

    return (
        <div>
            <div className='accessory-card-grid'>
                {listArray()}
            </div>

            <Modal
                modalStatus={modalEditAccessory}
                changeStatus={setModalEditAccessory}
                w={82}
                content={
                    <EditAccessory id={accessoryId} handleOnSuccess={() => { setModalEditAccessory(false); handleOnSuccess() }} btCancelAction={() => setModalEditAccessory(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteAccessory(accessoryId)}
                message="Deseja realmente excluir esse acessório?"
                itemName={accessoryName}
            />

            <ImageLightbox
                src={lightboxItem ? `/images/accessory/${lightboxItem.image}` : null}
                alt={lightboxItem?.name}
                caption={lightboxItem?.name}
                onClose={() => setLightboxItem(null)}
            />

        </div>
    )
}

export default ListAccessoryRow
